export class PbhRequestRemark {
  public RequestId?: number;
  public Remark?: string;
  public isCustomer?: boolean;
  public StatusCode?: number;
  public RemarkType?: number;
  public RemarkTypeCode?: string;
}
